import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Layout } from '../components/Layout';
import { RootState } from '../redux/store';
import { setTreatment, setPatientType } from '../redux/slices/appointmentSlice';
import { StepCard } from '../components/StepCard';
import { Button } from '../components/Button';
import { InputCard } from '../components/InputCard';
import { PatientTypeEnum } from '../types';
import { WelcomeMessage } from '../components/common/WelcomeMessage';
import { POSTING_PATIENT_CONFIG } from '../utils/constants';
import { Stethoscope, UserPlus, UserCheck, Users, Heart } from 'lucide-react';

const ICON_MAP = {
  UserPlus: <UserPlus size={12} />,
  UserCheck: <UserCheck size={12} />,
  Users: <Users size={12} />,
};


export const StepTreatment = () => {
  const selected = useSelector((s: RootState) => s.appointment.treatment);
  const { practice } = useSelector((s: RootState) => s.auth);
  const treatments = practice?.appointment_types || [];
  const showWelcomeMessage = practice?.show_welcome_message && practice?.welcome_message;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const proceed = () => {
    if (selected) {
      if (selected.allowedPatientPosting === 'new_patients_only') {
        dispatch(setPatientType(PatientTypeEnum.New));
        navigate(`../step-3`);
      } else if (selected.allowedPatientPosting === 'existing_patients_only') {
        dispatch(setPatientType(PatientTypeEnum.Existing));
        navigate(`../step-3`);
      } else {
        navigate(`../step-2`);
      }
    }
  };

  return (
    <Layout>
      <div className="space-y-4">
        <div className='flex flex-col items-center text-center md:items-start md:text-start'>
          <h1 className="text-2xl font-semibold text-black">Treatment type</h1>
          <p className="text-sm text-gray-500">Choose the service you'd like to schedule</p>
        </div>
        {showWelcomeMessage && (
          <WelcomeMessage message={practice?.welcome_message || ''} />
        )}
        <StepCard className={`flex flex-col justify-between overflow-y-auto ${showWelcomeMessage && '!h-[380px]'}`}>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {treatments.map(t => {
              const isSelected = selected?.id === t.id;
              const posting = t.allowedPatientPosting || 'both';
              const config = POSTING_PATIENT_CONFIG[posting as keyof typeof POSTING_PATIENT_CONFIG] || POSTING_PATIENT_CONFIG.both;

              return (
                <InputCard
                  key={t.id}
                  title={t.title}
                  isSelected={isSelected}
                  onClick={() => dispatch(setTreatment(t))}
                  variant="treatment"
                  badgeText={config.text}
                  badgeClass={config.badgeClass}
                  badgeIcon={ICON_MAP[config.iconName as keyof typeof ICON_MAP]}
                  icon={<Stethoscope size={24} className="text-blue-600" />}
                />
              );
            })}
          </div>
        </StepCard>

        <div className="flex justify-center md:justify-between">
          <span className='hidden md:block' />
          <Button title='Continue' disabled={!selected?.id} onClick={proceed} />
        </div>
      </div>
    </Layout>
  );
};




